import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FitnessCenter } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function ExerciseRequestRejectedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const {
    data: {
      exercise_request: { name, rejection_reason: rejectionReason }
    }
  } = notification;

  // El motivo se concatena al cuerpo: la fila muestra dos líneas y un bloque aparte se
  // cortaría de todos modos.
  const reason = rejectionReason
    ? ` ${t('exercise.rejected.reason', { ns: 'notifications' })}: ${rejectionReason}`
    : '';

  return (
    <NotificationRowContent
      notification={notification}
      icon={FitnessCenter}
      title={t('exercise.rejected.title', { ns: 'notifications' })}
      body={`${t('exercise.rejected.body', { name, ns: 'notifications' })}${reason}`}
    />
  );
}

ExerciseRequestRejectedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      exercise_request: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        rejection_reason: PropTypes.string,
        suggested_exercise: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string
        })
      }).isRequired
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default ExerciseRequestRejectedNotification;
